import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Set page title with environment label
const envLabel = import.meta.env.VITE_ENV_LABEL || (import.meta.env.DEV ? '(Local)' : '');
if (envLabel) {
  document.title = `Flock - Admin Support ${envLabel}`;
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
